import React from "react";
import { Stack } from "@mui/material";

import { HubTableTemplate } from "../../components";
import { useGetAllUserData } from "../../hooks";

import UsersStatusChip from "./UsersStatusChip";
import UsersDepartmentChips from "./UsersDepartmentChips";
import UserUserColumns from "./UserUserColumns";
import UsersRolesChips from "./UserRolesChips";
import UsersLocationChips from "./UserLocationChips";

const sortable = true;
const items = [
  {
    id: "status",
    label: "Status",
    sortable,
  },
  {
    id: "employeeId",
    label: "Employee ID",
    sortable,
  },
  {
    id: "name",
    label: "Name",
    sortable,
  },
  {
    id: "email",
    label: "Email",
    sortable,
  },
  {
    id: "locationId",
    label: "Location",
  },
  {
    id: "role",
    label: "Roles",
  },
  {
    id: "departments",
    label: "Departments",
  },
];

const keys = [
  {
    value: "status",
    CustomComponent: UsersStatusChip,
  },
  {
    value: "employeeId",
  },
  {
    value: "user",
    CustomComponent: UserUserColumns,
  },
  {
    value: "user.email",
  },
  {
    value: "locations",
    CustomComponent: UsersLocationChips,
  },
  {
    value: "role",
    CustomComponent: UsersRolesChips,
  },
  {
    value: "departments",
    CustomComponent: UsersDepartmentChips,
  },
];

export const UsersTable = ({ setOpen = () => {}, defaultLocation = 1 }) => {
  const { isLoading, data } = useGetAllUserData({ defaultLocation });

  const headerProps = { items };
  const bodyProps = {
    items: data?.rows,
    keys,
    onRowClick: (_, item) => setOpen(item?.user?.id),
  };
  const props = {
    headerProps,
    bodyProps,
    meta: data?.meta,
    isLoading,
  };

  return (
    <Stack gap="10px" overflow="hidden">
      <HubTableTemplate id="UsersTable" {...props} />
    </Stack>
  );
};

export default UsersTable;
